<!--
 * @Author: DY
 * @Date: 2021-12-09 10:29:50
 * @LastEditTime: 2025-01-22 17:31:23
 * @Description:
 * @Param:
 * @FilePath: \ConcreteCloud_Web\src\App.vue
-->
<template>
    <router-view></router-view>
</template>
<script>
export default {
    name: 'app',
    data() {
        return {};
    },
    created() {},
    components: {},
    methods: {},
};
</script>

<style lang="stylus">
#app
    height 100%
.webchat-container
    z-index: 100;
    bottom: 10px;
    right: 10px;
    .nlux-comp-conversationStarter-prompt
        line-height: 14px !important
.webchat-bubble-tip
    z-index: 99;
    bottom: 20px;
    right: 20px;
</style>
